import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
    withStyles,
    TextField,
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    LinearProgress,
    FormControlLabel,
    Radio,
    FormControl,
    RadioGroup,
    FormLabel
} from '@material-ui/core/';

import {
    sendMessage
} from '@apricityhealth/web-common-lib/utils/Services';

class SendMessageDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: {
                message: 'Hello {{context.patient.firstName}}, this is a message from Apricity Health. {{context.patientURL}}',
                subject: 'Message from Apricity Health',
                providerId: props.appContext.state.userId,
                contactMethod: 'userPreference'
            },
            selectedContact: ''
        };
        if (props.patient) {
            this.state.message.patientId = props.patient.patientId;
            this.state.message.to = props.patient.patientId;
        } else if (props.provider) {
            this.state.message.providerId = props.provider.providerId;
            this.state.message.to = props.provider.providerId;
        }
    }


    onCancel() {
        const { onCancel } = this.props;
        if (onCancel)
            onCancel();
    }

    onDone() {
        let self = this;
        const { onDone, appContext } = this.props;
        const { message } = this.state;

        self.setState({ progress: <LinearProgress /> });
        sendMessage(appContext, message).then((response) => {
            self.setState({ progress: null });
        }).catch(function (error) {
            self.setState({ progress: error.message });
        });

        if (onDone)
            onDone(message);
    }

    onChange(e) {
        let { message } = this.state;
        let type = e.target.name;
        message[type] = e.target.value;

        this.setState({ message });
        console.log("onChange:", message );
        if (this.props.onChange)
            this.props.onChange(message);
    }

    getContactOptions() {
        const { selectedContact } = this.state;
        const { patient, provider } = this.props;
        const preferred = patient?.contactMethod || provider?.contactMethod;

        const contacts = [];
        const emails = patient?.emails || provider?.emails;
        for (let i = 0; i < emails.length; i++) {
            const email = emails[i];
            contacts.push(<FormControlLabel value={JSON.stringify({ contactMethod: 'email', email: email.email })} control={<Radio name='email' />} label={email.email} />);
        }

        const phones = patient?.phoneNumbers || provider?.phoneNumbers;
        for (let i = 0; i < phones.length; i++) {
            const phone = phones[i];
            contacts.push(<FormControlLabel value={JSON.stringify({ contactMethod: 'phone', phone: phone.number })} control={<Radio name='phone' />} label={phone.number} />);
        }

        return <FormControl align='left'>
            <FormLabel >Contacts</FormLabel>
            <RadioGroup
                aria-label="contacts"
                name="contacts"
                value={selectedContact}
                onChange={(e) => {
                    console.log("onChange:", e.target.value );
                    const newMessage = { ...this.state.message };
                    delete newMessage.phone;
                    delete newMessage.email;
                    if ( e.target.value ) {
                        Object.assign(newMessage, JSON.parse(e.target.value ));
                    } else {
                        newMessage.contactMethod = "userPreference";
                    }
                    this.setState({ message: newMessage, selectedContact: e.target.value });
                    if ( this.props.onChange ) {
                        this.props.onChange(newMessage);
                    }

                    console.log("newMessage:", newMessage );
                }}
            >
                <FormControlLabel value={''} control={<Radio />} label={`User Preference (${preferred})`} />
                {contacts}
            </RadioGroup>
        </FormControl>;
    }

    render() {
        const { message } = this.state;
        const { name } = this.props

        const title = name && <div>Select the contact to send a message to <b>{name}</b></div>
        const contactSelector = this.getContactOptions();

        return (
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                model="false"
                open={true}
            >
                <DialogContent >
                    {title}
                    <div style={{ marginTop: '20px' }} />
                    <div align='left' style={{ align: 'left' }}>
                        {contactSelector}
                    </div>
                    <div style={{ marginTop: '20px' }} />
                    <TextField
                        fullWidth
                        name='subject'
                        label="Subject:"
                        width='200' height='100'
                        value={message.subject}
                        onChange={(e) => { this.onChange(e, "subject") }}
                    />
                    <div style={{ marginTop: '10px' }} />
                    <TextField
                        fullWidth
                        multiline={true}
                        name='message'
                        rows={2}
                        label="Message:"
                        variant="outlined"
                        width='200' height='100'
                        value={message.message}
                        onChange={(e) => { this.onChange(e, "message") }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" self={this} style={styles.button} onClick={(e) => { this.onDone() }}>Send</Button>
                    <Button variant="contained" self={this} style={styles.button} onClick={(e) => { this.onCancel() }}>Cancel</Button>
                </DialogActions>
            </Dialog>

        )
    }
}

const styles = {
    div: {
        margin: 10
    },

    button: {
        margin: 10
    }
};

SendMessageDialog.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object.isRequired
};


export default withStyles(styles)(SendMessageDialog);
